/**
 * ダイアログ表示/非表示
 * # 非表示
 * @param {*} false 引数にfalseを指定することでダイアログの非表示を試みる
 * # 表示
 * @param {*} title タイトル部分に表示する文字列（リソースID不可、未指定で空欄）
 * @param {*} message メッセージ部分に表示する文字列（リソースID不可、未指定で空欄）
 * @param {*} buttonLabel ボタン部分に表示する文字列（リソースID不可、未指定でボタン非表示）
 * @param {*} btn_action ボタン押下時の動作、未指定の場合はダイアログ非表示処理
 * @param {*} btn_cancel 右上の×ボタン押下時の動作、未指定の場合はダイアログ非表示処理
 * @returns 
 */
export default function Dialog(props) {
  //console.dir(props);

  /**
   * ダイアログ非表示
   * @returns true
   */
  function closeDialog() {
    var target = document.querySelector("#cb_foreground_layer");
    target.classList.remove('active');
    var dialog = document.querySelector("#Dialog");
    if (dialog) {
      dialog.remove();
    }
    return true;
  }

  if (!props) {
    return closeDialog();
  }

  /**
   * 直接呼出し/history経由対応のマッピング変換
   */
  var params;
  if (props.location) {
    params = props.location.state;
  }
  else {
    params = props;
  }
  var title = params.title ?? "";
  var message = params.message ?? "";
  var btnLabel = params.buttonLabel ?? null;
  var action = params.btn_action ?? function(){closeDialog()};
  var close = params.btn_cancel ?? function(){closeDialog()};

  var target = document.querySelector("#cb_foreground_layer");
  // Frame
  var dialog = document.createElement('div');
  dialog.id = "Dialog";
  dialog.className = "dialog";
  // Header
  var header = document.createElement('div');
  header.className = "header";
  var headerTitle = document.createElement('p');
  headerTitle.innerText = title;
  var headerClose = document.createElement('div');
  headerClose.className = "cancel";
  headerClose.addEventListener("click", function() {
      console.log('cancel');
      close();
  }, false);
  header.appendChild(headerTitle);
  header.appendChild(headerClose);
  // Body
  var body = document.createElement('div');
  body.className = "body";
  body.innerText = message;
  // Footer
  var footer = document.createElement('div');
  footer.className = "footer";
  var footerContents = document.createElement('p');
  footerContents.className = "action_btn";
  if (btnLabel) {
    var footerAction = document.createElement('button');
    footerAction.className = "btn_l acceptbtn";
    footerAction.addEventListener("click", function() {
        console.log('action');
        action();
    }, false);
    footerAction.innerText = btnLabel;
    footerContents.appendChild(footerAction);
  }
  footer.appendChild(footerContents);

  // 結合 
  dialog.appendChild(header);
  dialog.appendChild(body);
  dialog.appendChild(footer);
  target.appendChild(dialog);
  target.classList.add('active');
}

